import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import CardInfoDoctorComponent from "./cardInfoDoctor";
import "./styles.css";
import { disabledDays, onClickDay } from "./controller";

const FourthQuestionComponent = ({
  responseAvailableDates,
  setAppointmentSelected,
  appointmentSelected,
  openModalInfoPatientAndAppointment,
  appointmentSelectedByClickOnCard,
  reasonSelected,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const currentDate = new Date();

  const onConFirm = () => {
    if (appointmentSelected) {
      openModalInfoPatientAndAppointment();
    }
  };

  useEffect(() => {
    if (
      responseAvailableDates &&
      responseAvailableDates.availableDates &&
      Object.keys(responseAvailableDates.availableDates).length > 0
    ) {
      const availableDates = responseAvailableDates.availableDates;
      const firstAvailableDate = Object.keys(availableDates).sort()[0];
      const formattedFirstAvailableDate = new Date(firstAvailableDate);
      setSelectedDate(formattedFirstAvailableDate);
      setSelectedAppointment(availableDates[firstAvailableDate]);
    }
  }, [responseAvailableDates]);

  return (
    <div className="containerFourthQuestion">
      <div className="headerSection">
        <div className="mainTitle">Consulta gratuita de cirugía plástica</div>
        <p className="subtitle">
          Valoración médica personalizada por nuestra cirujana plástica Marta de
          Juan. Sin compromiso · Sin coste
        </p>
      </div>
      <div className="calendarAndHours">
        <div className="columnCalendar">
          <Calendar
            value={selectedDate}
            tileDisabled={({ date }) =>
              disabledDays({ date }, responseAvailableDates, currentDate)
            }
            onClickDay={(day) =>
              onClickDay(
                day,
                responseAvailableDates,
                setSelectedAppointment,
                setSelectedDate,
                setAppointmentSelected,
              )
            }
          />
        </div>
        {selectedAppointment !== null && (
          <div className="columnHours">
            <CardInfoDoctorComponent
              selectedAppointment={selectedAppointment}
              setAppointmentSelected={setAppointmentSelected}
              appointmentSelectedByClickOnCard={
                appointmentSelectedByClickOnCard
              }
            />
          </div>
        )}
      </div>

      <div className="containerBtnConfirmar">
        <button 
          className="btnConfirmarCita" 
          onClick={onConFirm}
          disabled={!appointmentSelected}
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default FourthQuestionComponent;
